import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const Disclaimer: React.FC = () => (
  <PolicyPage slug="disclaimer" subtitle="Disclaimer" />
);

export default Disclaimer;
